// Cached element refs, layout constants, and small DOM utilities.

const byId = (id: string) => document.getElementById(id) as HTMLElement;

export const tbody = byId("tbody");
export const tlHead = byId("tlHead");
export const grid = byId("grid");
export const gridWrap = document.querySelector(".grid-wrap") as HTMLElement;
export const versionView = byId("versionView");
export const projTitle = byId("projTitle") as HTMLInputElement;
export const statusBox = byId("statusBox");
export const conflictBar = byId("conflictBar");
export const tagList = byId("tagList");
export const totalLabel = byId("totalLabel");
export const progressLabel = byId("progressLabel");
export const leftEmpty = byId("leftEmpty");
export const populateBtn = byId("populateBtn");
export const ioModal = byId("ioModal");
export const projectModal = byId("projectModal");

export const PX_PER_DAY = 26;
// fixed column widths (px); the # column is sized per render from WBS depth.
// est = single/plain & sum-column width; estStream = per-stream column; estSum = Σ column.
export const COL_W = { leaf: 52, task: 400, tags: 180, copy: 60, ver: 72, comp: 110, est: 100, estStream: 88, estSum: 76, deps: 64, act: 150 };
// The estimate column(s) are built dynamically (0..N streams + optional Σ) between comp and
// deps — see computeTimeline/syncEstColumns — so there is no static `est` ref here.
export const colEls = {
  wbs: byId("colWbs"), leaf: byId("colLeaf"), task: byId("colTask"), tags: byId("colTags"),
  copy: byId("colCopy"), ver: byId("colVer"), comp: byId("colComp"),
  deps: byId("colDeps"), act: byId("colAct"), tl: byId("colTl"),
};
colEls.leaf.style.width = COL_W.leaf + "px";
colEls.task.style.width = COL_W.task + "px";
colEls.tags.style.width = COL_W.tags + "px";
colEls.ver.style.width = COL_W.ver + "px";
colEls.comp.style.width = COL_W.comp + "px";
colEls.copy.style.width = COL_W.copy + "px";
colEls.deps.style.width = "0px"; // dynamic; computeTimeline sets it (0 unless dependency counting is on)
colEls.act.style.width = COL_W.act + "px";

// place a floating card under the anchor, clamped to the viewport (position:fixed)
export function positionCard(pop: HTMLElement, anchor: HTMLElement): void {
  const r = anchor.getBoundingClientRect();
  const w = pop.offsetWidth, h = pop.offsetHeight;
  pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8)) + "px";
  pop.style.top = (r.bottom + 4 + h > window.innerHeight ? Math.max(8, r.top - h - 4) : r.bottom + 4) + "px";
}

export function iconBtn(label: string, title: string, onclick: () => void, rotate?: number): HTMLButtonElement {
  const b = document.createElement("button");
  b.title = title;
  b.onclick = onclick;
  if (rotate) {
    // rotate a single glyph so every direction is pixel-identical regardless of font
    const s = document.createElement("span");
    s.textContent = label;
    s.style.display = "inline-block";
    s.style.transform = `rotate(${rotate}deg)`;
    b.appendChild(s);
  } else {
    b.textContent = label;
  }
  return b;
}

export function copyToClipboard(text: string, el: HTMLElement | null, label = "✓ Copied"): void {
  const flash = () => {
    if (!el) return;
    const original = el.textContent;
    el.classList.add("copied");
    el.textContent = label;
    setTimeout(() => { el.classList.remove("copied"); el.textContent = original; }, 800);
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(flash).catch(() => fallbackCopy(text, flash));
  } else {
    fallbackCopy(text, flash);
  }
}

function fallbackCopy(text: string, done: () => void): void {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand("copy"); } catch { /* ignore */ }
  document.body.removeChild(ta);
  done();
}
